/*----------------------
       SLIDER
---------------------- */
SliderMedia = {
  init: function () {
    var swiper = new Swiper(".swiper-about-media", {
      slidesPerView: "auto",
      loop: true,
      centeredSlides: true,
      speed: 600,
      lazy: true,
      navigation: {
        nextEl: ".swiper-about-media-next",
      },
    });
  }
};

$(document).ready(function () {
  SliderMedia.init();
});
$(document).on('shopify:section:load', function (event) {
  SliderMedia.init();
});